
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ButtonToTop extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly showTopButton!: boolean;

  private goToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
